export const CAMPAIGN_ID = 'CAMPAIGN_ID';
export const CAMPAIGN = 'CAMPAIGN';
export const GENERAL_ERRORS = 'GENERAL_ERRORS';
export const RESET = 'RESET';
